/**
 * Central tracker configuration for the app
 */
export const TrackerConfig = {
  /** Default WebSocket trackers for WebTorrent */
  defaultWssTrackers: [
    'wss://tracker.openwebtorrent.com',
    'wss://tracker.btorrent.xyz',
    'wss://tracker.fastcast.nz',
    'wss://tracker.webtorrent.dev',
    'wss://tracker.files.fm:7073/announce',
  ],
} as const;
